import overrides from '@salesforce/retail-react-app/app/theme'
import breakpoints from './foundations/breakpoints'
import layerStyles from './foundations/layer-styles'
import {
    delonghiFonts,
    delonghiTypography,
    kenwoodFonts,
    kenwoodTypography,
    nutribulletFonts,
    nutribulletTypography,
    braunFonts,
    braunTypography,
} from './import/fonts'

export const delonghiProjectOverrides = {
    ...overrides,
    ...delonghiFonts,
    ...breakpoints,
    ...layerStyles,
    ...delonghiTypography,
}

export const kenwoodProjectOverrides = {
    ...overrides,
    ...kenwoodFonts,
    ...breakpoints,
    ...layerStyles,
    ...kenwoodTypography,
}

export const nutribulletProjectOverrides = {
    ...overrides,
    ...nutribulletFonts,
    ...breakpoints,
    ...layerStyles,
    ...nutribulletTypography,
}

export const braunProjectOverrides = {
    ...overrides,
    ...braunFonts,
    ...breakpoints,
    ...layerStyles,
    ...braunTypography,
}
